// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"style__placeholder__rhDFW"};